import * as React from 'react';

import { cn } from '@rematter/ui-web';

type Props = {
  title: string;
  hideDivider?: boolean;
  children: React.ReactNode;
  className?: string;
};

export const SalesOrderTabCustomerSectionInfo: React.FC<Props> = ({
  title,
  hideDivider = false,
  children,
  className,
}) => (
  <div
    className={cn(
      '@SalesOrderTabCustomerSectionInfo',
      cn(
        '@SalesOrderTabCustomerInfoSection',
        cn('@InfoSection mb-3 flex flex-col gap-2', className),
      ),
    )}
  >
    <div className="text-base font-bold">{title}</div>
    <div className="flex flex-col gap-1">{children}</div>
    {hideDivider ? null : <div className="mt-4 border-t border-neutral/20" />}
  </div>
);
